// 富文本图片处理
import { ElLoading } from 'element-plus'
import {getCookie} from "./cookie"
var localObj = window.location;
let commenUrl = process.env.VUE_APP_PUBLIC_PATH
if(!commenUrl){
    commenUrl = localObj.protocol + "//" + localObj.host+process.env.VUE_APP_PUBLIC_NAME+'/sr/';
}
/**
 * 处理富文本中的Base64图片
 * @param {string} html - 富文本HTML内容
 * @param {string} uploadUrl - 图片上传API地址
 * @returns {Promise<string>} 处理后的富文本
 */
async function processImages(html, uploadUrl) {
  // 1. 正则表达式匹配所有Base64图片
  const base64Regex = /<img[^>]+src="(data:image\/[^;]+;base64[^"]+)"[^>]*>/g;
  const blobRegex = /<img\s[^>]*?src\s*=\s*['"](blob:[^'"]*?)['"][^>]*>/gi;
  // 2. 收集所有匹配到的图片
  const matches = [];
  let match;
  while ((match = base64Regex.exec(html)) !== null) {
    const [meta, base64] = match[1].split(',');
    const mimeType = meta.match(/:(.*?);/)[1];
    const blob = base64ToBlob(base64, mimeType);
    matches.push({
      fullTag: match[0],
      base64Data: match[1],
      base64Blob: blob,
      mimeType: mimeType,
    });
  }
  while ((match = blobRegex.exec(html)) !== null) {
    const response = await fetch(match[1]);
    if (!response.ok) throw new Error('获取Blob失败');
    blob = await response.blob();
    mimeType = blob.type;
    matches.push({
      fullTag: match[0],
      base64Data: match[1],
      base64Blob: blob,
      mimeType: mimeType,
    });
  }
  // 3. 没有Base64图片直接返回
  if (matches.length === 0) return html;
  const loading = ElLoading.service({
    lock: true,
    text: '图片上传中...',
    background: 'rgba(0, 0, 0, 0.7)',
  })
  // 4. 处理每张图片的上传和替换
  let processedHtml = html;
  for (const { fullTag, base64Data,base64Blob, mimeType} of matches) {
    try {
      // 提取MIME类型和纯Base64数据
      // const [meta, base64] = base64Data.split(',');
      // const mimeType = meta.match(/:(.*?);/)[1];
      
      // 上传图片
      const imageUrl = await uploadImage({
        mimeType,
        blob: base64Blob,
        uploadUrl
      });

      // 创建新img标签并替换
      const newTag = fullTag.replace(
        /src="[^"]+"/, 
        `src="${imageUrl}"`
      );
      
      processedHtml = processedHtml.replace(fullTag, newTag);
    } catch (error) {
      console.error('图片上传失败，保留Base64格式:', error);
      // 上传失败时保留原图
    }
  }
  loading.close()
  return processedHtml;
}

/**
 * 上传Base64图片到服务器
 * @param {Object} param0 
 * @returns {Promise<string>} 图片URL
 */
async function uploadImage({ mimeType, blob, uploadUrl }) {
  // 1. 创建FormData
  const formData = new FormData();
  // const blob = base64ToBlob(base64Data, mimeType);
  formData.append('image', blob, `image.${mimeType.split('/')[1]}`);
  
  // 2. 发送上传请求
  const response = await fetch(uploadUrl, {
    method: 'POST',
    body: formData,
    headers: { 
      'Access-Control-Allow-Origin': '*',
      "Authorization": JSON.parse(getCookie('userInfoIndustry')).tokenType + ' ' + JSON.parse(getCookie('userInfoIndustry')).accessToken
     }
    
  });

  // 3. 处理响应
  if (!response.ok) {
    throw new Error(`上传失败: ${response.status}`);
  }
  
  const data = await response.json();
  return commenUrl + data.result.filesMap.image[0].path; // 假设接口返回{ url: "https://..." }
}

/**
 * 将Base64转换为Blob
 * @param {string} base64 - 纯Base64数据（不含前缀）
 * @param {string} mimeType - MIME类型
 * @returns {Blob}
 */
function base64ToBlob(base64, mimeType) {
  const byteString = atob(base64);
  const arrayBuffer = new ArrayBuffer(byteString.length);
  const uintArray = new Uint8Array(arrayBuffer);
  
  for (let i = 0; i < byteString.length; i++) {
    uintArray[i] = byteString.charCodeAt(i);
  }
  
  return new Blob([arrayBuffer], { type: mimeType });
}

// HTML转义函数
const escapeHtml = (html)=> {
    return html
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
}

export {processImages}